// Generated by CoffeeScript 1.10.0
(function() {
  var Router, config, filter, includes, last, link, sortBy;

  Router = require('react-router');

  filter = require('lodash/collection/filter');

  sortBy = require('lodash/collection/sortBy');

  last = require('lodash/array/last');

  includes = require('underscore.string/include');

  config = require('config').config;

  link = require('./gatsby-helpers').link;

  module.exports = function(pages, pagesReq) {
    var filteredPages, handler, htmlWrapper, i, j, len, len1, markdownWrapper, page, parentRoute, parentRoutes, parentTemplateFile, parentTemplates, templateFile, templateFiles, templates;
    templates = {};
    templates.root = Router.createRoute({
      name: 'root-template',
      path: link("/"),
      handler: pagesReq('./_template')
    });
    templateFiles = filter(pages, function(page) {
      return page.file.name === "_template" && page.file.dirname !== ".";
    });
    for (i = 0, len = templateFiles.length; i < len; i++) {
      templateFile = templateFiles[i];
      parentTemplates = filter(templateFiles, function(template) {
        return includes(templateFile.requirePath, template.file.dirname);
      });
      parentTemplates = sortBy(parentTemplates, function(template) {
        return template != null ? template.file.dirname.length : void 0;
      });
      parentTemplateFile = last(parentTemplates);
      parentRoute = templates[parentTemplateFile != null ? parentTemplateFile.file.dirname : void 0];
      if (!parentRoute) {
        parentRoute = templates.root;
      }
      templates[templateFile.file.dirname] = Router.createRoute({
        name: templateFile.file.dirname + "-template",
        path: link(templateFile.templatePath),
        parentRoute: parentRoute,
        handler: pagesReq("./" + templateFile.requirePath)
      });
    }
    filteredPages = filter(pages, function(page) {
      return page.file.name.slice(0, 1) !== '_';
    });
    markdownWrapper = require('wrappers/md');
    htmlWrapper = require('wrappers/html');
    for (j = 0, len1 = filteredPages.length; j < len1; j++) {
      page = filteredPages[j];
      switch (page.file.ext) {
        case "md":
          handler = markdownWrapper;
          page.data = pagesReq("./" + page.requirePath);
          break;
        case "html":
          handler = htmlWrapper;
          break;
        case "jsx":
          handler = pagesReq("./" + page.requirePath);
          page.data = pagesReq("./" + page.requirePath).metadata ? pagesReq("./" + page.requirePath).metadata() : void 0;
          break;
        case "cjsx":
          handler = pagesReq("./" + page.requirePath);
          page.data = pagesReq("./" + page.requirePath).metadata ? pagesReq("./" + page.requirePath).metadata() : void 0;
          break;
        default:
          handler = pagesReq("./" + page.requirePath);
      }
      parentRoutes = filter(templateFiles, function(templateFile) {
        return includes(page.requirePath, templateFile.file.dirname);
      });
      parentRoutes = sortBy(parentRoutes, function(route) {
        return route != null ? route.file.dirname.length : void 0;
      });
      parentTemplateFile = last(parentRoutes);
      parentRoute = templates[parentTemplateFile != null ? parentTemplateFile.file.dirname : void 0];
      if (!parentRoute) {
        parentRoute = templates.root;
      }
      if (includes(page.path, "/index") && parentRoute.file.dirname === parentTemplateFile.file.dirname) {
        Router.createDefaultRoute({
          name: page.path,
          parentRoute: parentRoute,
          handler: handler
        });
      } else {
        Router.createRoute({
          name: page.path,
          path: link(page.path),
          parentRoute: parentRoute,
          handler: handler
        });
      }
    }
    return templates.root;
  };

}).call(this);



/** WEBPACK FOOTER **
 ** ../~/gatsby/dist/isomorphic/create-routes.js
 **/